import { render } from "./LbrxCartSideBarPortrait.vue?vue&type=template&id=0faed0f2"
import script from "./LbrxCartSideBarPortrait.vue?vue&type=script&lang=js"
export * from "./LbrxCartSideBarPortrait.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__